<ng-container *ifScreenSize="screenType.Mobile">
  <ng-container *ngIf="isHomePage; else pageHeader">
    <ng-container *ngIf="memberCard$ | async as memberCard; else loadingRef">
      <div class="mobile-page-header container py-3" [style.height.px]="height" [ngClass]="{ 'show-after': showAfter }">
        <div class="d-flex flex-column h-100 border-disabled rounded gap-3">
          <div class="d-flex justify-content-between">
            <!--Name and ID-->
            <div class="card-id text-start">
              <h5 class="mb-1 mb-lg-1 font-size-18 fw-bold card-name text-white" *ngIf="memberDetails$ | async as memberDetails">
                {{ memberDetails.FirstName }} {{ memberDetails.Surname }}
              </h5>
              <div class="d-flex mb-0 mb-lg-2 card-name-info text-white">
                <div>
                  {{ memberCard.MemberId }}
                </div>
                <div class="px-1">-</div>
                <div>{{ 'member.card.id' | translate }}</div>
              </div>
            </div>
            <button class="btn d-flex btn-redirect-wallet bg-glass" [routerLink]="'/rewards/wallet'">
              <div class="icon material-symbols-outlined">qr_code_scanner</div>
              <div class="text-white">{{ 'member.card.wallet' | translate }}</div>
            </button>
          </div>

          <!-- points and cash -->
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex mb-1 points-container w-100 justify-content-between">
              <div class="points-item bg-glass">
                <span class="icons material-icons" aria-hidden="true">loyalty</span>
                <div class="points-balance">
                  <div class="text-number font-size-18">
                    {{ pointsBalance$ | async | number: '1.0-0' }}
                  </div>
                  <div class="text-unit font-size-12">{{ 'member.card.points' | translate }}</div>
                </div>
              </div>
              <div class="points-item bg-glass">
                <span class="icons material-symbols-outlined"> money_bag </span>
                <div class="e-cash-section" *ngIf="ecash$">
                  <div class="text-number font-size-18">{{ ecash$ | async | FortressCurrencyPipe }}</div>
                  <div class="text-unit font-size-12">{{ 'member.card.ecash.balance' | translate }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- ecash button -->
          <div class="w-100 bg-glass ecach-button">
            <fgb-ecash-button [isMemberCard]="true" [cardRouteURL]="'/payment'"></fgb-ecash-button>
          </div>

          <!-- navigation -->
          <ng-container>
            <div class="mobile-navigation d-flex flex-row align-items-center pb-2 mb-2">
              <div class="navigation" routerLink="/rewards">
                <span class="icons material-symbols-outlined bg-glass mb-1"> redeem </span>
                <a class="text-white font-size-14">{{ 'member.card.rewards' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/challenges-v2">
                <span class="icons material-symbols-outlined bg-glass mb-1"> emoji_events </span>
                <a class="text-white font-size-14">{{ 'member.card.challenges' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/games">
                <span class="icons material-symbols-outlined bg-glass mb-1"> stadia_controller </span>
                <a class="text-white font-size-14">{{ 'member.card.games' | translate }}</a>
              </div>

              <div class="navigation" routerLink="/earn">
                <span class="icons material-symbols-outlined bg-glass mb-1"> money </span>
                <a class="text-white font-size-14">{{ 'member.card.earn' | translate }}</a>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>

    <ng-template #loadingRef>
      <fgb-loading></fgb-loading>
    </ng-template>
  </ng-container>

  <ng-template #pageHeader>
    <div class="page-header bg-primary" [ngClass]="{ 'hide-footer': !showFooter }">
      <div class="d-flex align-items-center text-white">
        <div class="banner-name">
          <a (click)="goBack()" class="btn back-btn text-white px-0">
            <span class="icon material-icons" aria-hidden="true">arrow_back_ios</span>
          </a>
          <h4 class="font-size-20 mb-0" [ngClass]="{ 'text-title-center': !showBalance }">
            {{ pageTitle | translate | uppercase }}
          </h4>
        </div>
        <div *ngIf="showBalance" class="ms-auto d-flex align-items-center widget-details">
          <div class="balance-details d-flex bg-glass-dark align-items-center">
            <span class="icons material-icons"> loyalty </span>
            <div class="balance">
              <p class="mb-0 font-size-14 fw-bold">{{ pointsBalance$ | async | number: '1.0-0' : 'en-GB' }}</p>
            </div>
          </div>

          <button *ngIf="showQr" class="qrcode-btn text-white bg-glass-dark" (click)="gotoWallet()">
            <span class="icon material-icons material-mobile-nav">qr_code_2</span>
          </button>
        </div>
      </div>
      <div class="footer"></div>
    </div>
  </ng-template>
</ng-container>
